/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
// import './node_modules/universalviewer/dist/esm/index.css';

import "./src/styles/vidstack.css"
import "./src/styles/fonts.css"
import "./src/styles/base.css"
import "./src/styles/uoy.theme.css"
import "./src/styles/layout.css"
import "./src/styles/tailwind.css"

export const onRouteUpdate = ({ location }) => {
  const gaId = process.env.GATSBY_GA_MEASUREMENT_ID
  if (
    !gaId ||
    typeof window === "undefined" ||
    typeof window.gtag !== "function"
  ) {
    return
  }

  window.gtag("event", "page_view", {
    page_path: `${location.pathname}${location.search}${location.hash}`,
    page_location: window.location.href,
    page_title: document.title,
  })
}
